import validate from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@4.0.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.15.19_@vue+compile_147243a096f5cebdd2240bd122693881/node_modules/nuxt/dist/pages/runtime/validate.js";
import docs_45version_45global from "/home/runner/work/nuxt.com/nuxt.com/app/middleware/docs-version.global.ts";
import manifest_45route_45rule from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@4.0.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.15.19_@vue+compile_147243a096f5cebdd2240bd122693881/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  docs_45version_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/nuxt.com/nuxt.com/app/middleware/auth.ts"),
  guest: () => import("/home/runner/work/nuxt.com/nuxt.com/app/middleware/guest.ts")
}